//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  data() {
    return {
      markets: [],
      outcomesVisible: true
    }
  },
  props: ['market', 'event'],
  watch: {

  },
  mounted() {
  },
  computed: {

    visible() {
        return this.outcomesVisible
    },
    grid() {
      if (_.get(this.market, 'cols') > 2) {
        return 'grid-cols-3'
      }
      return 'grid-cols-2'
    },
    error() {
      return this.$store.state.betbuilder.error
    }
  },
  methods: {
    toggle() {
      this.outcomesVisible = !this.outcomesVisible
    },
    show() {
      this.outcomesVisible = true
    },
    hide() {
      this.outcomesVisible = false
    }

  }
}
